const e = {
  undo: "Angre",
  redo: "Gjenta",
  confirm: "Bekreft",
  clear: "Fjern",
  more: "mer",
  cancel: "Kanseller",
  update: "Oppdater"
}, t = {
  positiveText: "Bekreft",
  negativeText: "Kanseller"
}, r = {
  placeholder: "Velg",
  loading: "Laster"
}, a = {
  clear: "Fjern",
  now: "Nå",
  confirm: "Bekreft",
  selectTime: "Velg tid",
  selectDate: "Velg dato",
  datePlaceholder: "Velg dato",
  datetimePlaceholder: "Velg dato og tid",
  monthPlaceholder: "Velg måned",
  yearPlaceholder: "Velg år",
  quarterPlaceholder: "Velg kvartal",
  startDatePlaceholder: "Startdato",
  endDatePlaceholder: "Sluttdato",
  startDatetimePlaceholder: "Startdato og -klokkeslett",
  endDatetimePlaceholder: "Sluttdato og -klokkeslett",
  startMonthPlaceholder: "Startmåned",
  endMonthPlaceholder: "Sluttmåned",
  today: "I dag"
}, l = {
  checkTableAll: "Velg alle i tabellen",
  uncheckTableAll: "Fjern markeringen av alle i tabellen",
  confirm: "Bekreft",
  clear: "Fjern",
  apply: "Bruk",
  filters: "Filtre",
  sort: "Sorter"
}, n = {
  sourceTitle: "Kilde",
  targetTitle: "Mål"
}, o = {
  selectAll: "Velg alle",
  unselectAll: "Fjern markeringen av alle",
  clearAll: "Fjern"
}, i = {
  description: "Ingen info"
}, d = {
  placeholder: "Velg"
}, c = {
  placeholder: "Velg tid",
  positiveText: "OK",
  negativeText: "Kanseller",
  now: "Nå"
}, s = {
  goto: "Gå til",
  selectionSuffix: "side",
  next: "Neste",
  previous: "Forrige"
}, g = {
  add: "Legg til"
}, k = {
  loading: "Laster"
}, p = {
  placeholder: "Skriv inn"
}, m = {
  placeholder: "Skriv inn"
}, u = {
  create: "Opprett"
}, f = {
  title: "Temaeditor",
  clearAllVars: "Fjern alle variabler",
  clearSearch: "Tøm søk",
  filterCompName: "Filtrer etter navn på komponent",
  filterVarName: "Filtrer etter variabelnavn",
  import: "Importer",
  export: "Eksporter",
  restore: "Tilbakestill til standard"
}, h = {
  tipPrevious: "Forrige bilde (←)",
  tipNext: "Neste bilde (→)",
  tipCounterclockwise: "Mot klokken",
  tipClockwise: "Med klokken",
  tipZoomOut: "Zoom ut",
  tipZoomIn: "Zoom inn",
  tipClose: "Lukk (Esc)",
  tipOriginalSize: "Zoom til opprinnelig størrelse"
}, S = {
  heading: "Sortering og filtre",
  sortHeading: "Sorter etter",
  newestFirst: "Nyeste først",
  oldestFirst: "Eldste først",
  ascending: "Stigende",
  descending: "Synkende",
  apply: "Bruk",
  clear: "Fjern",
  cancel: "Kanseller",
  filters: "Filtre"
}, T = {
  noMatchingFound: "Ingen samsvarende resultater funnet"
}, P = {
  margin: "Margin",
  padding: "Innholdsavstand",
  reset: "Tilbakestill",
  errorMsg: "Utstedt verdi er ugyldig."
}, v = {
  brandColors: "Merkevarefarger",
  noBrandColors: "Du har ikke lagt til noen merkevarefarger ennå.",
  getStarted: "Kom i gang",
  add: "Legg til",
  default: "Standard"
}, F = {
  addColor: "Legg til ny farge",
  editColor: "Rediger farge",
  add: "Legg til",
  noData: "Du har ikke lagt til noen farger ennå.",
  invalidCode: "Ugyldig fargekode",
  defaultColor: "Standardfarger"
}, b = {
  global: e,
  Popconfirm: t,
  Cascader: r,
  DatePicker: a,
  DataTable: l,
  LegacyTransfer: n,
  Transfer: o,
  Empty: i,
  Select: d,
  TimePicker: c,
  Pagination: s,
  DynamicTags: g,
  Log: k,
  Input: p,
  InputNumber: m,
  DynamicInput: u,
  ThemeEditor: f,
  Image: h,
  SortFilter: S,
  IconPicker: T,
  Spacing: P,
  BrandColorPicker: v,
  BrandBoard: F
};
export {
  F as BrandBoard,
  v as BrandColorPicker,
  r as Cascader,
  l as DataTable,
  a as DatePicker,
  u as DynamicInput,
  g as DynamicTags,
  i as Empty,
  T as IconPicker,
  h as Image,
  p as Input,
  m as InputNumber,
  n as LegacyTransfer,
  k as Log,
  s as Pagination,
  t as Popconfirm,
  d as Select,
  S as SortFilter,
  P as Spacing,
  f as ThemeEditor,
  c as TimePicker,
  o as Transfer,
  b as default,
  e as global
};
